import React from 'react';
import PromoStrip from '../../../ui/PromoStrip';
import { PROMO_STRIP } from '../../../staticContent';
import { WpWidget } from '../../../widgets/WpChrome';
import { USE_WP_WIDGETS } from '../../../GlobalValues';

/** §9 (ligne 2.c) : « bons plans » du listing — même logique que PricesWidget. */
const PromoWidget = () => {
  const staticVersion = <PromoStrip id="offre-moment" {...PROMO_STRIP} />;
  return USE_WP_WIDGETS ? <WpWidget slug="bons-plans" fallback={staticVersion} /> : staticVersion;
};

export default PromoWidget;
